module.exports = __webpack_public_path__ + "static/media/hostel.0c34f7f3.png";